export enum Currency {
  USD = 'USD',
  BTC = 'BTC',
  SAT = 'SAT',
  MCN = 'MCN',
}
